(() => {
  const handles = [
    'egyptian-dukkah-feta-jar',
    'italian-antipasti-mozzarella-jar',
    'french-berry-nut-cream-jar'
  ];
  const root = window.Shopify?.routes?.root || '/';
  const money = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  });
  let productRequest;

  const preserveQuery = (href) => {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return href;
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.append(key, value);
    });
    return `${url.pathname}${url.search}${url.hash}`;
  };

  document.querySelectorAll('[data-tca-preserve-query]').forEach((link) => {
    link.href = preserveQuery(link.getAttribute('href'));
  });

  const getProducts = (fresh = false) => {
    if (!productRequest || fresh) {
      productRequest = Promise.all(handles.map(async (handle) => {
        const response = await fetch(`${root}products/${handle}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) throw new Error('product');
        const product = await response.json();
        const variant = product.variants.find((item) => item.available);
        return { handle, product, variant };
      }));
    }
    return productRequest;
  };

  const updateInstance = (instance, products) => {
    let total = 0;
    let ready = true;
    products.forEach(({ handle, variant }) => {
      const item = instance.querySelector(`[data-tca-flight-item][data-handle="${handle}"]`);
      if (!item || !variant) {
        ready = false;
        return;
      }
      item.dataset.variantId = variant.id;
      item.querySelector('[data-tca-flight-price]').textContent = money.format(variant.price / 100);
      total += variant.price;
    });
    instance.querySelector('[data-tca-flight-total]').textContent = money.format(total / 100);
    instance.dataset.value = String(total / 100);
    const button = instance.querySelector('[data-tca-flight-add]');
    button.dataset.ready = ready ? 'true' : 'false';
    button.classList.toggle('is-unavailable', !ready);
    if (!ready) {
      button.setAttribute('aria-disabled', 'true');
      button.querySelector('[data-tca-flight-label]').textContent = 'Choose available jars';
      instance.querySelector('[data-tca-flight-status]').textContent = 'One or more flight jars are currently unavailable. Browse the collection to choose an alternative.';
    } else {
      button.removeAttribute('aria-disabled');
    }
    return { ready, total };
  };

  const flightToken = () => {
    const key = 'tca_tasting_flight_id';
    let token = sessionStorage.getItem(key);
    if (!token) {
      token = window.crypto?.randomUUID?.() || `flight-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(key, token);
    }
    return token;
  };

  const matchingLines = (cart, token, variantIds) => cart.items.filter((item) =>
    variantIds.includes(String(item.variant_id)) && item.properties?._tca_flight_id === token
  );

  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };

  const showSuccess = (instance, cart, total) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    const button = instance.querySelector('[data-tca-flight-add]');
    button.dataset.added = 'true';
    button.classList.add('is-added');
    button.href = preserveQuery(instance.dataset.cartUrl);
    button.removeAttribute('aria-busy');
    button.querySelector('[data-tca-flight-label]').textContent = 'Flight added · View bag';
    instance.querySelector('[data-tca-flight-status]').textContent = `Three jars added to your bag — ${money.format(total / 100)}.`;
  };

  document.querySelectorAll('[data-tca-flight]').forEach((instance) => {
    const button = instance.querySelector('[data-tca-flight-add]');
    const label = button.querySelector('[data-tca-flight-label]');
    const status = instance.querySelector('[data-tca-flight-status]');

    getProducts().then((products) => updateInstance(instance, products)).catch(() => {
      status.textContent = 'Live availability could not be checked. Browse the collection to choose your jars.';
    });

    button.addEventListener('click', async (event) => {
      if (button.dataset.added === 'true' || button.dataset.ready !== 'true') return;
      event.preventDefault();
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Checking today’s jars…';
      status.textContent = '';

      try {
        const products = await getProducts(true);
        const state = updateInstance(instance, products);
        if (!state.ready) {
          button.removeAttribute('aria-busy');
          return;
        }

        const token = flightToken();
        const items = products.map(({ handle, product, variant }) => ({
          id: variant.id,
          quantity: 1,
          properties: {
            _tca_flight: 'Atelier Tasting Flight',
            _tca_flight_id: token,
            _tca_product_handle: handle
          },
          handle,
          title: product.title,
          price: variant.price
        }));
        const variantIds = items.map((item) => String(item.id));
        let cart = await fetchCart();
        const existing = matchingLines(cart, token, variantIds);
        if (existing.length === items.length) {
          showSuccess(instance, cart, state.total);
          return;
        }
        if (existing.length > 0) {
          throw new Error('partial');
        }

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items.map(({ id, quantity, properties }) => ({ id, quantity, properties }))
          })
        });
        if (!response.ok) throw new Error('add');

        cart = await fetchCart();
        if (matchingLines(cart, token, variantIds).length !== items.length) throw new Error('verify');
        showSuccess(instance, cart, state.total);

        const payload = {
          event: 'tca_tasting_flight_add',
          currency: 'INR',
          value: state.total / 100,
          product_handles: handles.slice(),
          variant_ids: items.map((item) => String(item.id)),
          ecommerce: {
            currency: 'INR',
            value: state.total / 100,
            items: items.map((item) => ({
              item_id: item.handle,
              item_name: item.title,
              item_variant: String(item.id),
              price: item.price / 100,
              quantity: 1
            }))
          }
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        window.Shopify?.analytics?.publish?.('tca_tasting_flight_add', payload);
        window.dispatchEvent(new CustomEvent('tca_tasting_flight_add', { detail: payload }));
      } catch (error) {
        button.removeAttribute('aria-busy');
        label.textContent = 'Review your bag';
        button.href = preserveQuery(instance.dataset.cartUrl);
        button.dataset.added = 'true';
        status.textContent = error.message === 'partial'
          ? 'Part of this flight is already in your bag. Review quantities before trying again.'
          : 'We could not confirm all three jars. Review your bag before trying again.';
      }
    });
  });
})();
